<section class="join-revolution">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-12">
                <h1 class="join-tag">Join the<br> Revolution</h1>
                <p>Step into a platform where gaming meets rewards, leaderboards, and real community energy. Sign in with your mobile number, discover fresh titles, and turn every session into progress.</p>
                <h3>Game On. Level up. Stay Pro</h3>
                <button class="join-btn" (click)="onJoinNow()">JOIN NOW</button>
            </div>
            <div class="col-lg-6 col-12">
                <img src="assets/img/svg/yogamez@2x.png" alt="Join Revolution" class="join-img">
            </div>
        </div>
    </div>
</section>
